import { JackpotLogo } from './logo';
import { JackpotStage } from './stage';
import { JackpotStars } from './stars';
import { Container } from '@pixi/react';
import { JackpotProjector } from './projector';
import { ScaleComponent } from '../../../../components';

export const JackpotBackGround: React.FC = () => {
  return (
    <Container {...({ name: 'JackpotBackGround' } as any)}>
      <ScaleComponent positionX={window.innerWidth / 2} isTop>
        <JackpotLogo />
      </ScaleComponent>
      <ScaleComponent positionX={window.innerWidth / 2} isBottom>
        <JackpotStage />
      </ScaleComponent>
      <JackpotStars />
      <JackpotProjector />
    </Container>
  );
};
